import { LoginData } from "@/components/Portal/UserAccount/Security/LoginData";
import { TwoFactorAuthStatus } from "@/components/Portal/UserAccount/Security/TwoFactorAuthStatus";

export const SecurityView = () => (
  <div className="flex flex-col gap-8">
    <LoginData />
    <TwoFactorAuthStatus />
  </div>
);
